import { PersonRelationshipViewModel } from '../../models/Entities/Person/Relationship/PersonRelationshipModels';
import { CommonState } from '../common/state/commonState';

export interface PersonRelationshipState extends CommonState<PersonRelationshipViewModel> {
    lastCreated?: PersonRelationshipViewModel;
}

export const PersonRelationshipUnloadState: PersonRelationshipState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
